import React from 'react'
import { Card } from '@jsluna/react'
import { PropTypes } from 'prop-types'
import timeOnDateFormat from '../../../utils/formatDateTime'
import stringHelpers from '../../../utils/stringHelpers'
import { toTitleCase } from '../../../utils/common'

const displayCompleteText = (isComplete) => {
  switch (isComplete) {
    case true:
      return 'Yes'
    case false:
      return 'No'
    case null:
      return 'System handed back'
    default:
      return ''
  }
}

const formatAuthorisedBy = (email) => {
  const name = stringHelpers.getNameFromEmail(email)
  return toTitleCase(name)
}

const mapDetails = (details) => {
  const { actionRequired } = details
  return (
    details.passDetails.map(x =>
      <Card key={x.PassType} className="ln-u-border-top">
        <h3 className="ln-u-margin-bottom">{x.PassType}</h3>
        { actionRequired === 'Authorisation' &&
        <div>
          <p className="ln-u-margin-bottom">Pass number: <b>{x.visitPassId}</b></p>
          <p className={actionRequired === 'Authorisation' ? 'ln-u-margin-bottom*2' : 'ln-u-margin-bottom'}>
          Time submitted: <b>{timeOnDateFormat(x.PassSubmittedOn)}</b>
          </p>
        </div>
        }
        { actionRequired === 'Authorised' &&
        <div>
          <p className="ln-u-margin-bottom">Pass number: <b>{x.visitPassId}</b></p>
          <p className={actionRequired === 'Authorisation' ? 'ln-u-margin-bottom*2' : 'ln-u-margin-bottom'}>
           Time submitted: <b>{timeOnDateFormat(x.PassSubmittedOn)}</b>
          </p>
          <p className="ln-u-margin-bottom"> Authorised by: <b>{formatAuthorisedBy(x.AuthorisedBy)}</b></p>
          <p className="ln-u-margin-bottom"> Time authorised: <b>{timeOnDateFormat(x.TimeAuthorised)}</b></p>
          <p className="ln-u-margin-bottom"> Expiry time: <b>{timeOnDateFormat(x.ExpiryTime)}</b></p>
        </div>
        }  
        {
          actionRequired === 'Sign off' &&
          <div>
            <p className="ln-u-margin-bottom"> Authorised by: <b>{formatAuthorisedBy(x.AuthorisedBy)}</b></p>
            <p className="ln-u-margin-bottom"> Time authorised: <b>{timeOnDateFormat(x.TimeAuthorised)}</b></p>
            <p className="ln-u-margin-bottom"> Expiry time: <b>{timeOnDateFormat(x.ExpiryTime)}</b></p>
            <p className="ln-u-margin-bottom"> Time handed back: <b>{timeOnDateFormat(x.TimeHandedBack)}</b></p>
            {
              displayCompleteText(x.IsFireWatchCompleted) !== '' &&
              <div>
                <p className="ln-u-margin-bottom">
                  Fire watches complete: <b>{displayCompleteText(x.IsFireWatchCompleted)}</b>
                </p>
                {
                  !x.IsFireWatchCompleted &&
                  <div>
                    <p className="ln-u-margin-bottom">
                      Fire watches completed by: <b>{toTitleCase(x.FireWatchCompletedBy)}</b>
                    </p>
                  </div>
                }
              </div>
            }
            <p className={x.WorkComplete === false ? 'ln-u-margin-bottom' : 'ln-u-margin-bottom*2'}>
              Work complete: <b>{displayCompleteText(x.WorkComplete)}</b>
            </p>
            {
              x.WorkComplete === false &&
              <div>
                <p className="ln-u-margin-bottom*2">Hand back notes:</p>
                <p className="ln-u-margin-bottom*2"><b>{x.HandbackNotes}</b></p>
              </div>
            }
          </div>
        }
        <hr />
        {x.Questions.map(q => (
          <div key={q.question.Id}>
            <p className="ln-u-margin-bottom">{q.question.Question}</p>
            <p className="ln-u-margin-bottom*2"><b>{q.AnswerText === '' ? 'Nothing written' : q.AnswerText}</b></p>
          </div>
        ))}
      </Card>
    )
  )
}

const DetailsCard = (props) => {
  window.scrollTo(0, 0)
  return mapDetails(props)
}

DetailsCard.propTypes = {
  actionRequired: PropTypes.string
}

DetailsCard.defaultProps = {
  actionRequired: 'test'
}


export default DetailsCard



// WEBPACK FOOTER //
// ./src/components/Passes/PassDetails/DetailsCard.jsx